<!-- 客户管理-权限分配 -->
<template>
<!-- 模板一，不改变面包屑 -->
  <div class="mainArea ClientAuthAllot">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!--权限选择-->
        <el-tree
          class="allotTree"
          ref="tree"
          :data="treeData.access_list"
          show-checkbox
          node-key="function_id"
          :default-checked-keys="treeData.company_access_list"
          :props="treeData.defaultProps"
          default-expand-all>
        </el-tree>

        <!-- 确认 -->
        <el-button
          class="confirm"
          type="primary"
          @click="getCheckedKeys"
          v-if="treeData.access_list.length !== 0">确 认</el-button>
      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../Layout/BreadCrumb.vue"
  import { 
      showToast
    } from "../../../../static/js/utility/utility.js"
  import { clientMApi } from "../../../../static/js/api.js"

  export default {
    name: 'ClientAuthAllot',
    components: {
      BreadCrumb
    },
    data() {
      return {
        treeData: {
          // 权限列表
          access_list: [],
          // 	用户已选权限
          company_access_list: [],
          defaultProps: {
            children: 'children',
            label: 'function_name'
          }
        }
      }
    },
    mounted(){
      console.log('', this.$route.query.company_id)
      this.getClientAuthList()
    },
    created: async function () {
    },
    methods: {
      // 数据处理
      processData: function (data) {
        this.treeData.access_list = data.access_list
        this.treeData.company_access_list = data.company_access_list
        console.log('权限列表', this.treeData.access_list)
      },
      // 获取客户权限列表
      getClientAuthList: async function () {
        let vm = this
        let data = {
          company_id: this.$route.query.company_id
        }

        let res = await clientMApi.getClientAuthList(data)
        if (res.meta.code === 200) {
          // console.log('权限列表', res.data)
          vm.processData(res.data)
        } else {
          showToast(res.meta.message)
        }
      },
      // 新增客户权限，返回客户信息列表
      addClientAuth: async function (accessList) {
        let vm = this
        let data = {
          company_id: this.$route.query.company_id,
          accessList: accessList
        }

        let res = await clientMApi.addClientAuth(data)
        if (res.meta.code === 200) {
          showToast('权限分配成功')
          // 返回上一页
          setTimeout(function () {
            vm.$router.go(-1)
          }, 1000)
        } else {
          showToast(res.meta.message)
        }
      },
      // 确认新增
      getCheckedKeys() {
        // console.log(this.$refs.tree.getCheckedKeys());
        let accessList = this.$refs.tree.getCheckedKeys()
        this.addClientAuth(accessList)
      }
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    },
    props: []
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Page/ClientManage/ClientAuthAllot.vue